import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import axios from "axios";
import requestInstance from "./Request";

let env = process.env.REACT_APP_API_BASE_URL;
const token = localStorage.getItem("token");
const requestPayment = axios.create({
    baseURL: env,
    headers:{
      "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,  
    }
  });
export const paymentApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Payment.api}`, data)
    .catch((err) => err.response);
    return setCurrentUser(res);
};

export const paymentHashApi = async (data) => {
  const res = await requestPayment
  .post(`${env}${API_ENDPOINT.Payment.hashApi}`,data)
  .catch((err) => err.response);
  return setCurrentUser(res);
}

// Payment Method API
export const paymentMethodApi = async(data) => {
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.Payment.paymentMethodApi}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}
